module.exports = __webpack_public_path__ + "static/img/icon-mask1.ab37ec2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-mask1.png
// module id = m0/y
// module chunks = 0